import { atom } from 'jotai';
import { AssignedToFilter } from '../api/assignedToFilter.ts';

export const patientSearchTextAtom = atom('');

export const patientAssignedToAtom = atom<AssignedToFilter>(AssignedToFilter.ALL);
export const patientAssignedEmployeeIdsAtom = atom<Set<string>>(new Set<string>());

export enum PatientTableView {
  FINDINGS = 'FINDINGS',
  THERAPY = 'THERAPY',
  CONTACT_TRACING = 'CONTACT_TRACING',
  SCREENING = 'SCREENING',
}

export const patientTableViewAtom = atom<PatientTableView>(PatientTableView.FINDINGS);

export const patientTableActiveOnly = atom<boolean>(true);

export enum PatientTableFilter {
  FINDINGS_WITH_CLINICAL_REPORT = 'FINDINGS_WITH_CLINICAL_REPORT',
  FINDINGS_WITHOUT_CLINICAL_REPORT = 'FINDINGS_WITHOUT_CLINICAL_REPORT',
  FINDINGS_WITH_LAB_REPORT = 'FINDINGS_WITH_LAB_REPORT',
  FINDINGS_WITHOUT_LAB_REPORT = 'FINDINGS_WITHOUT_LAB_REPORT',

  THERAPY_NO_THERAPY = 'THERAPY_NO_THERAPY',
  THERAPY_PHASE1 = 'THERAPY_PHASE1',
  THERAPY_PHASE2 = 'THERAPY_PHASE2',
  THERAPY_ENDED_NOT_COMPLETED = 'THERAPY_ENDED_NOT_COMPLETED',
  THERAPY_COMPLETED = 'THERAPY_COMPLETED',
  THERAPY_DOT = 'THERAPY_DOT',
  THERAPY_CONDITION_OVERDUE = 'THERAPY_CONDITION_OVERDUE',
  THERAPY_HOSPITALIZED = 'THERAPY_HOSPITALIZED',
  THERAPY_ISOLATED = 'THERAPY_ISOLATED',

  CT_NOT_NEEDED = 'NOT_NEEDED',
  CT_UNKNOWN = 'UNKNOWN',
  CT_NOT_STARTED = 'NOT_STARTED',
  CT_COMPLETED = 'COMPLETED',
  CT_NOT_COMPLETED = 'NOT_COMPLETED',

  SCREENING_WITH_CLINICAL_REPORT = 'SCREENING_WITH_CLINICAL_REPORT',
  SCREENING_WITHOUT_CLINICAL_REPORT = 'SCREENING_WITHOUT_CLINICAL_REPORT',
}

export const patientTableFiltersAtom = atom<Set<PatientTableFilter>>(new Set([]));
